import { useEffect, useState } from "react";
import { Dialog, Button, Stack } from "@mui/material";
import FormTemplate from "../templates/FormTemplate";
import FormInput from "../molecules/FormInput";
import { useTranslation } from "react-i18next";
import { Timelog } from "../../services/swagger";

interface DateDialogProps {
  mode: "create" | "edit";
  selectedTimelog?: Timelog;
  onDateChange: (startDate: string, endDate?: string) => void;
  onClose: () => void; // Prop to handle closing the dialog
}
export default function DateDialog(props: DateDialogProps) {
  const { t } = useTranslation("DateDialog");
  const [startDate, setStartDate] = useState<string | undefined>("");
  const [endDate, setEndDate] = useState<string | undefined>("");

  const handleSubmit = async () => {
    // You can add your logic for submitting the form here
    if (startDate) {
      await props.onDateChange(startDate, endDate);
    }
    props.onClose(); // Close the dialog after submission
  };

  function toLocalISOString(date: Date): string {
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16);
  }

  useEffect(() => {
    if (props.mode === "edit" && props.selectedTimelog) {
      const { startDate, endDate } = props.selectedTimelog;

      setStartDate(toLocalISOString(new Date(startDate)));
      setEndDate(endDate ? toLocalISOString(new Date(endDate)) : "");
    }
  }, [props.mode, props.selectedTimelog]);

  return (
    <FormTemplate
      title={t("StartAndEndDates")}
      noForm
      confirm
      submitButtonText={t("Set")}
      onSubmit={handleSubmit}
      onCancel={props.onClose} // Close dialog on cancel
    >
      <Stack spacing={1}>
        <FormInput
          field="startDate"
          label={t("StartDate")}
          type="date"
          value={startDate}
          required
          inputType="datetime-local"
          onChange={(v) => setStartDate(v as string)} // Update start date
        />
        <FormInput
          field="endDate"
          label={t("EndDate")}
          type="date"
          value={endDate}
          inputType="datetime-local"
          onChange={(v) => setEndDate(v as string)} // Update end date
        />
      </Stack>
    </FormTemplate>
  );
}
